import type { ReductionsState } from "../../../../aysa_api/features/reductions_state/v1/reductions_state.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  encodePersonalizedDiscountToken,
  decodePersonalizedDiscountToken,
} from "../../../../aysa_api/features/discount/v1/discount";
import {
  encodeUnlockedCouponTokens,
  decodeUnlockedCouponTokens,
} from "../../../../aysa_api/features/coupon/v1/unlocked_coupon_tokens";

export const createBaseReductionsState = (): ReductionsState => {
  return {};
};

export const decodeReductionsState = (
  reader: Reader,
  length: number
): ReductionsState => {
  const end = reader.pos + length;
  const message = createBaseReductionsState();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 2:
        message.discount = decodePersonalizedDiscountToken(
          reader,
          reader.uint32()
        );

        break;
      case 3:
        message.unlockedCouponTokens = decodeUnlockedCouponTokens(
          reader,
          reader.uint32()
        );

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeReductionsState = (
  writer: Writer,
  message: ReductionsState
): Writer => {
  if (message.discount !== undefined) {
    encodePersonalizedDiscountToken(
      writer.uint32(18).fork(),
      message.discount
    ).ldelim();
  }
  if (message.unlockedCouponTokens !== undefined) {
    encodeUnlockedCouponTokens(
      writer.uint32(26).fork(),
      message.unlockedCouponTokens
    ).ldelim();
  }

  return writer;
};
